/* eslint-disable camelcase */
import React, { useState, useMemo } from 'react';
import classNames from 'classnames';
import { useToggle, useLockFn } from 'ahooks';
import { Avatar, Author, RichText } from '@/common/components';
import { fetchCommentLike } from '@/modules/article/models/model';
import { useAuth } from '@/common/contexts/auth-context';

import styles from './index.module.scss';

export interface UserInfo {
  id: number;
  avatar: string;
  mem_id: number;
  trackable_token: string;
  name: string;
  judge: number;
  position_judge: number;
  career: string;
  position: string;
  gender: number;
}

export interface CommentProps {
  id: number;
  u: UserInfo;
  cmt: CommentProps[];
  t: string;
  likes: number;
  mylike: number;
  time_str: string;
}

const Comment: React.FC<{ data: CommentProps }> = (props) => {
  const { data } = props;

  const [likeCnt, setLikeCnt] = useState(data.likes);
  const [liked, { toggle }] = useToggle(data.mylike === 1);
  const { isAuth } = useAuth();

  const handleClickLike = useLockFn(async () => {
    await fetchCommentLike(data.id, liked ? 0 : 1);
    toggle();
    setLikeCnt((v) => (liked ? v - 1 : v + 1));
  });

  const avatar = useMemo(() => {
    if (isAuth) {
      return data.u.avatar;
    }
    if (data.u.gender === 2) {
      return 'https://i9.taou.com/maimai/p/28220/9168_6_4LoXeLSWpwLwBY';
    }
    return 'https://i9.taou.com/maimai/p/30264/2127_113_6pf7eBYYthmEmNz5-a160';
  }, [data, isAuth]);

  return (
    <div className='py-4'>
      <Author
        avatar={
          <Avatar
            size='36'
            contact={{
              ...data.u,
              avatar,
            }}
          />
        }
        name={isAuth ? data.u.name : data.u.name[0] + (data.u.gender === 2 ? '女士' : '先生')}
        description={data.u.career}
        judge={data.u.judge}
        positionJudge={data.u.position_judge}
      />
      <div className='ml-11'>
        <p className='text-[#222] text-base pt-2 whitespace-pre-wrap'>
          <RichText text={data.t} />
        </p>
        {data.cmt?.length > 0 && (
          <div className='px-3 py-2 mt-2 text-sm text-gray-600 bg-gray-100 rounded-lg'>
            {data.cmt.map((cmt) => (
              <div key={cmt.id} className='mt-2 first:mt-0'>
                <span className='font-medium'>
                  {isAuth ? cmt.u.name : cmt.u.name[0] + (cmt.u.gender === 2 ? '女士' : '先生')}：
                </span>
                <RichText text={cmt.t} />
              </div>
            ))}
          </div>
        )}
        <div className='flex items-center justify-between pt-2'>
          <div className='text-xs text-[#AFB1BC]'>{data.time_str}</div>
          <div className={classNames(styles.like, { [styles.active]: liked })} onClick={handleClickLike}>
            <i className={classNames('inline-block -mb-px w-3 h-3 cursor-pointer bg-contain', styles.like_icon)} />
            <span className='ml-1 text-xs'>{likeCnt || ''}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Comment);
